import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { GeneratePdfService } from './services/generate-pdf.service';
import { GlobalShadowStyleDirective } from '@ptl/global-components';

@Component({
    selector: 'app-resource-download',
    templateUrl: './resource-download.component.html',
    styleUrls: ['./resource-download.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class ResourceDownloadComponent extends GlobalShadowStyleDirective {

  @Input() documentName: string;

  constructor(
    private generatePdfService: GeneratePdfService
  ) {
    super();
   }

  generatePdf(){
    this.generatePdfService.downloadPdf();
  }

}
